import { messageHandlerRegistry } from '@reducers/v2/messagesBus/handlerRegistry';
import { ImageDocumentMessageType } from '@reducers/v2/messagesBus/types';
import { TTL_FOR_IMAGE } from '@v2/components/imageHandling/constants';
import { removeImageDocumentMessageHandler } from './removeImageDocumentMessageHandler';
import { cropImageDocumentMessageHandler } from './cropImageDocumentMessageHandler';
import { rotateImageDocumentMessageHandler } from './rotateImageDocumentMessageHandler';
import { updateImageMetadataMessageHandler } from './updateImageMetadataMessageHandler';
import { uploadImageDocumentMessageHandler } from './uploadImageDocumentMessageHandler';

Object.values(ImageDocumentMessageType).forEach((type) => {
  messageHandlerRegistry.configure(type, { ttl: TTL_FOR_IMAGE });
});

messageHandlerRegistry.register(ImageDocumentMessageType.IMAGE_DELETED, ({ message }) =>
  removeImageDocumentMessageHandler(message.payload)
);
messageHandlerRegistry.register(ImageDocumentMessageType.IMAGE_CROPPED, ({ message }) =>
  cropImageDocumentMessageHandler(message.payload)
);
messageHandlerRegistry.register(ImageDocumentMessageType.IMAGE_ROTATED, ({ message }) =>
  rotateImageDocumentMessageHandler(message.payload)
);
messageHandlerRegistry.register(ImageDocumentMessageType.IMAGE_METADATA_UPDATED, ({ message }) =>
  updateImageMetadataMessageHandler(message.payload)
);
messageHandlerRegistry.register(ImageDocumentMessageType.IMAGE_UPLOAD, ({ message }) =>
  uploadImageDocumentMessageHandler(message.payload)
);
